




import { Component } from 'vue-property-decorator';
import { Route, RawLocation } from 'vue-router';
import { Form as FormBase, EntityStoreActions, EntityStoreGetters, EntityStoreMutations, createEntity, NewEntity, asFormData, FormData } from '@/base';
import { CreditJson, CreditState } from '../json';
import { EmailJson } from '@/modules/email';
import { EmailTemplateType } from '@/modules/emailtemplate';
import { FileEntityCollectionJson, FileEntityJson } from '@/modules/file';
import store, { Actions } from '../store';
import { store as EmailStore, Actions as EmailAction } from '@/modules/email';
import { getEnumByName } from '@/util';
import EmailBase from '../../../email/views/EmailBase.vue';
import { EmailActiveItem } from '../../../email/views/EmailActiveItem';

@Component<Email>({
  beforeRouteEnter(to, from, next): void {
    next(vm => vm.handleBeforeRouteEnter(to, from, next));
  },
})
export default class Email extends EmailBase<CreditJson> {
  /**
   * Returns file attachment collection of the active item.
   */
  public get formData(): FormData<FileEntityCollectionJson> | null {
    return this.activeItem ? asFormData(this.activeItem.email.fileAttachmentCollection) : null;
  }

  /**
   * Changes the active item.
   */
  protected changeActiveItem(item: EmailActiveItem<CreditJson> | null): void {
    const activeCredit = store[EntityStoreGetters.ACTIVE_ITEM];
    const activeItem = this.activeItem;

    // set the credit active
    store[EntityStoreMutations.ACTIVE_ITEM](item ? item.entity : null);

    if (item) {
      // Keep the original values in prototype.
      item = {
        entity: item.entity,
        email: item.email,
      };
    }

    this.activeItem = item;

    if (activeCredit && (!item || item.entity !== activeCredit.$raw)) {
      activeCredit.$revoke();
    }
  }

  /**
   * Called when closing the form.
   */
  protected onClose(): void {
    this.$router.push({ name: 'credit' });
  }

  private handleBeforeRouteEnter(to: Route, from: Route, next: (to?: RawLocation | false) => void): void {
    const creditId = parseInt(to.params.id, 10);
    const emailTemplateId = parseInt(to.params.emailTemplateId, 10);

    const isInvalidUrl = isNaN(creditId) || isNaN(emailTemplateId);
    const isTranslator = to.path.includes('translator');
    const promise = isInvalidUrl
      ? Promise.reject()
      : Promise.all([
          store[EntityStoreActions.READ_ONE]({ id: creditId, initial: true }),
          store[Actions.READ_EMAIL]({ credit: creditId, emailTemplate: emailTemplateId, isTranslator }),
        ]);

    promise
      .then(([credit, email]) => this.open(() => ({ entity: credit, email })))
      .then(handled => next(handled ? undefined : { path: from.fullPath, replace: true }))
      .catch(() => next(from.fullPath === '/' && !from.name ? { name: 'credit', replace: true } : { path: from.fullPath, replace: true }));
  }
}
